/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecondFactorViewRequest
 */
export interface SecondFactorViewRequest {
    /**
     * 
     * @type {string}
     * @memberof SecondFactorViewRequest
     */
    intermediateToken: string;
    /**
     * 
     * @type {string}
     * @memberof SecondFactorViewRequest
     */
    challengeResponse: string;
}

/**
 * Check if a given object implements the SecondFactorViewRequest interface.
 */
export function instanceOfSecondFactorViewRequest(value: object): value is SecondFactorViewRequest {
    if ((!('intermediateToken' in (value as Record<string, any>)) && !('intermediate_token' in (value as Record<string, any>))) || ((value as Record<string, any>)['intermediateToken'] === undefined && (value as Record<string, any>)['intermediate_token'] === undefined)) return false;
    if ((!('challengeResponse' in (value as Record<string, any>)) && !('challenge_response' in (value as Record<string, any>))) || ((value as Record<string, any>)['challengeResponse'] === undefined && (value as Record<string, any>)['challenge_response'] === undefined)) return false;
    return true;
}

export function SecondFactorViewRequestFromJSON(json: any): SecondFactorViewRequest {
    return SecondFactorViewRequestFromJSONTyped(json, false);
}

export function SecondFactorViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecondFactorViewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'intermediateToken': json['intermediate_token'],
        'challengeResponse': json['challenge_response'],
    };
}

export function SecondFactorViewRequestToJSON(json: any): SecondFactorViewRequest {
    return SecondFactorViewRequestToJSONTyped(json, false);
}

export function SecondFactorViewRequestToJSONTyped(value?: SecondFactorViewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'intermediate_token': value['intermediateToken'],
        'challenge_response': value['challengeResponse'],
    };
}

